import { Link } from "react-router-dom";

// Small "see our Refund Policy" line shown under pay buttons.
export default function RefundNote({ className = "", testId = "refund-policy-link" }) {
  return (
    <p className={`text-[11px] text-foreground/50 ${className}`}>
      Digital purchases are non-refundable once accessed. See our{" "}
      <Link to="/refund-policy" target="_blank" rel="noopener" className="underline hover:text-terracotta" data-testid={testId}>
        Refund Policy
      </Link>
      .
    </p>
  );
}
